import React from 'react';
import Skeleton, { SkeletonContainer, SkeletonVariants }
  from '@fuww/library/src/SkeletonLoader';

interface SkeletonLoaderProperties {
  variant?: SkeletonVariants;
}

const SkeletonLoader = ({ variant }: SkeletonLoaderProperties) => (
  <SkeletonContainer className="skeleton-loader">
    <Skeleton variant={variant} />
  </SkeletonContainer>
);

export default SkeletonLoader;
